export default __webpack_public_path__ + "ae307d24a8545dd093539dff68f7f58e.jpg";